import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface DesignNibIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const DesignNibIcon = ({ className, ...props }: DesignNibIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9_443)">
      <path
        d="M17.6744 11.4075L15.7691 17.1233C15.7072 17.309 15.5586 17.4529 15.3709 17.5087L3.69348 20.9803C3.22819 21.1186 2.79978 20.676 2.95328 20.2155L6.74467 8.84131C6.79981 8.67588 6.92419 8.54263 7.08543 8.47624L12.472 6.25822C12.696 6.166 12.9535 6.21749 13.1248 6.38876L17.5294 10.7935C17.6901 10.9542 17.7463 11.1919 17.6744 11.4075Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.29596 20.6016L9.65992 14.2377"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.7917 11.0557L20.6201 8.22724C21.4012 7.44619 21.4012 6.17986 20.6201 5.39881L18.4988 3.27749C17.7177 2.49644 16.4514 2.49644 15.6704 3.27749L12.8419 6.10592"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.7812 12.1163C11.1955 11.5305 10.2457 11.5305 9.65992 12.1163C9.07413 12.7021 9.07413 13.6519 9.65992 14.2376C10.2457 14.8234 11.1955 14.8234 11.7812 14.2376C12.367 13.6519 12.367 12.7021 11.7812 12.1163Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_9_443">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DesignNibIcon;
